var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 496.9 392.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#radial-gradient-2);stroke:#666;stroke-width:1.05px;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{stroke-miterlimit:10;}.cls-2{fill:#666;}.cls-2,.cls-4{stroke-width:.38px;}.cls-2,.cls-4,.cls-6{stroke:#000;}.cls-3{stroke-width:1.32px;}.cls-3,.cls-5{fill:lime;stroke:#009245;}.cls-4{fill:#999;}.cls-8{fill:#006837;}.cls-5{filter:url(#drop-shadow-1);stroke-width:1.62px;}.cls-6{fill:url(#radial-gradient);stroke-width:1.55px;}.cls-7{fill:#39b54a;stroke:#006837;stroke-width:1.14px;}"), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.1,
    dy: 7.62
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 12.19
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 488.66,
    cy: 112.06,
    fx: 613.31,
    fy: 43.26,
    r: 142.38,
    gradientTransform: "translate(-199.48 417.1) rotate(-54)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#4a4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#191919"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: -345.28,
    cy: -446.71,
    fx: -345.28,
    fy: -446.71,
    r: 15.74,
    gradientTransform: "translate(569.01 499.62) rotate(-20.12)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#1b1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0b0b0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 52.41,
    y: -52.41,
    width: 392.08,
    height: 496.9,
    transform: "translate(52.41 444.49) rotate(-90)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M75.28,281.64l-27.68-140.86c-2.93-14.93,8.5-32.22,23.2-35.11L373.17,48.74c11.02-2.17,21.73,5.15,23.93,16.34l29.03,147.76c3.14,15.96-7.07,31.41-22.79,34.5l-293.76,57.72c-15.79,3.1-31.15-7.38-34.3-23.41Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 142.65,
    y: -5.86,
    width: 191.79,
    height: 351.61,
    rx: 23.33,
    ry: 23.33,
    transform: "translate(359.31 -96.89) rotate(78.88)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 148.84,
    y: -0.22,
    width: 180,
    height: 340.21,
    rx: 22.24,
    ry: 22.24,
    transform: "translate(359.49 -97.22) rotate(78.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 91.16,
    cy: 198.9,
    r: 15.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 379.08,
    y: 135.31,
    width: 34.45,
    height: 7.28,
    rx: 2.39,
    ry: 2.39,
    transform: "translate(456.25 -276.71) rotate(78.88)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 391.21,
    cy: 113,
    r: 3.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 342.92,
    y: 247.12,
    width: 34.42,
    height: 6.54,
    rx: 3.27,
    ry: 3.27,
    transform: "translate(-41.52 74.13) rotate(-11.12)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.f0b9cafd.svg";
export { ForwardRef as ReactComponent };